<template>
  <a-layout>
    <a-tabs v-model="activeKey" style="margin-top: -4px">
      <a-tab-pane key="1" :tab="$t('tab.seedingList')" style="margin-top: -14px">
        <view-seeding-task-table ref="seedingList" :positionTypeId="queryParam.value.business.positionType.id" @dblclick="dblclick"/>
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('tab.seedingDetail')" forceRender style="margin-top: -14px">
        <view-seeding-task-detail ref="seedingDetail" :positionTypeId="queryParam.value.business.positionType.id"/>
      </a-tab-pane>
      <div slot="tabBarExtraContent">
        <a-space v-if="activeKey === '1'">
          <a-button type="primary" @click="refresh">{{$t('button.query')}}</a-button>
          <a-button type="primary" @click="reset">{{$t('button.reset')}}</a-button>
        </a-space>
      </div>
    </a-tabs>
  </a-layout>
</template>

<script>
import ViewSeedingTaskDetail from '@/views/outbound/view_seeding/ViewSeedingTaskDetail.vue'
import ViewSeedingTaskTable from '@/views/outbound/view_seeding/ViewSeedingTaskTable.vue'
import SupervisedModal from '@/views/modal/SupervisedModal.vue'

export default {
  name: 'ViewSeeding',
  components: { SupervisedModal, ViewSeedingTaskTable, ViewSeedingTaskDetail },
  props: {
    queryParam: { type: Object, default: null }
  },
  data() {
    return {
      activeKey: '1',
      generateDisable: false,
      reviewDisable: false,
      splitDisable: false,
      saveDisable: false,
      resetDisable: false,
      rePrintDisable: false,
      printAfterConfirmDisable: false,
      superviseDisable: false,
      positionData: []
    }
  },
  watch: {
    activeKey: {
      handler(value) {
        if (value === '1') {
          this.refresh()
        }
      }
    }
  },
  methods: {
    dblclick(e) {
      this.activeKey = '2'
      this.$refs.seedingDetail.zoneNo = e.zone.no
      this.$refs.seedingDetail.containerNo = e.container.no
      setTimeout(() => {
        this.$refs.seedingDetail.refresh()
      }, 400)
    },
    release() {
      this.$refs.seedingDetail.release()
    },
    allocatePackingPosition() {
      this.$refs.seedingDetail.allocatePackingPosition()
    },
    log() {
      this.$refs.seedingDetail.log()
    },
    refresh() {
      this.$refs.seedingList.refresh()
    },
    reset() {
      this.$refs.seedingList.reset()
    }
  }
}
</script>